var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgService = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.296 2.478h7.407l1.293 1.293v4.067l-1.293 1.293H4.296L3.004 7.838V3.771l1.292-1.293Zm.415 1-.707.707v3.239l.707.707h6.578l.707-.707v-3.24l-.707-.706H4.711ZM3.626 13.654 5.71 11.31h4.455l2.084 2.344.747-.664-2.382-2.68H5.261l-2.382 2.68.747.664Zm2.75-6.44v-2.82h-1v2.82h1ZM8.5 4.394v2.82h-1v-2.82h1Zm2.123 2.82v-2.82h-1v2.82h1Z",
    fill: "currentColor"
  })));
};
export default SvgService;